import { render, staticRenderFns } from "./printTamplate.vue?vue&type=template&id=25a821bb&scoped=true&"
import script from "./printTamplate.vue?vue&type=script&lang=js&"
export * from "./printTamplate.vue?vue&type=script&lang=js&"
import style0 from "./printTamplate.vue?vue&type=style&index=0&id=25a821bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a821bb",
  null
  
)

export default component.exports